var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shield 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 19,
    cy: 19,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 38 0 38 38 0 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,35 C10.1632,35 3,27.8368 3,19 C3,10.1632 10.1632,3 19,3 C27.8368,3 35,10.1632 35,19 C35,27.8368 27.8368,35 19,35 Z M17.4,23.8 L17.4,27 L20.6,27 L20.6,23.8 L17.4,23.8 Z M17.4,11 L17.4,20.6 L20.6,20.6 L20.6,11 L17.4,11 Z",
    id: "Shape",
    fill: "#104C8F",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bxs-shield",
    transform: "translate(10.000000, 9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.496,4.106 L9.523,0.106 C9.242,-0.037 8.91,-0.036 8.628,0.104 L0.601,4.104 C0.304,4.254 0.099,4.541 0.057,4.871 C0.044,4.968 -1.088,14.612 8.598,19.879 C8.746,19.96 8.911,20 9.075,20 C9.245,20 9.415,19.957 9.567,19.87 C18.874,14.611 18.081,5.297 18.043,4.903 C18.01,4.562 17.804,4.261 17.496,4.106 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.283e7032cd562d4e095344d703c6292d.svg";
export { ForwardRef as ReactComponent };